import { AxiosResponse } from 'axios';
import {
  DataWizardAct,
  LastStepVM,
  DocumentVM,
  ParentVM,
  SectionVM,
  TextActVM,
} from 'civil-status/view-models/step-form';
import { HttpResponse } from 'shell/models/http-response';
import { transformDocument } from './transform-document';
import { transformSubjects } from './transform-subjects';
import { transformSections } from './transform-sections';
import { transformText } from './transform-text';
import { transformTextAnnotationOld } from './transform-text-annotation-old';
import { transformDocumentEmergencyAct } from './transform-document-emergency-act';

export const transformerActWizardDataSaved = (
  response: AxiosResponse<HttpResponse<DataWizardAct>>
): LastStepVM => {
  const castedData: DataWizardAct = response?.data?.payload;

  const document: DocumentVM | undefined = transformDocument(castedData);
  const documentEmergencyAct: DocumentVM | undefined = transformDocumentEmergencyAct(castedData);
  const subjects: Record<string, ParentVM> | undefined = transformSubjects(castedData);
  const sections: Record<string, SectionVM> = transformSections(castedData);
  const textAct: TextActVM = transformText(castedData);
  const textAnnotationOld: TextActVM = transformTextAnnotationOld(castedData);

  return {
    document,
    documentEmergencyAct,
    ...(subjects || {}),
    ...(sections || {}),
    textAct,
    textAnnotationOld,
  } as LastStepVM;
};
